import addNamespacing from '@exodus/storage-enhancers/namespacing.js';
const serialize = (value) => JSON.stringify(value);
const deserialize = (text) => JSON.parse(text);
const createStorageNamespace = ({ localStorage }) => {
    const get = (key) => {
        const item = localStorage.getItem(key);
        return item == null ? undefined : deserialize(item);
    };
    const set = (key, value) => {
        if (value === undefined) {
            throw new Error(`cannot set "${key}" to undefined`);
        }
        localStorage.setItem(key, serialize(value));
    };
    const remove = (key) => {
        localStorage.removeItem(key);
    };
    const clear = async (prefix) => {
        const keys = [];
        for (let index = 0; index < localStorage.length; index++) {
            const key = localStorage.key(index);
            if (key?.startsWith(prefix)) {
                keys.push(key);
            }
        }
        keys.forEach((key) => localStorage.removeItem(key));
    };
    return addNamespacing({
        get: async (key) => get(key),
        batchGet: async (keys) => keys.map((key) => get(key)),
        set: async (key, value) => set(key, value),
        batchSet: async (object) => {
            for (const [key, value] of Object.entries(object)) {
                set(key, value);
            }
        },
        delete: async (key) => remove(key),
        batchDelete: async (keys) => Promise.all(keys.map((key) => remove(key))),
        clear,
    });
};
const createStorage = ({ localStorage = globalThis.localStorage } = Object.create(null)) => createStorageNamespace({ localStorage });
export default createStorage;
